import React from 'react';
import PropTypes from 'prop-types';

function DrawerSubMenuItem({ content, children }) {
  if (content > 0) {
    return (
      <div className="relative w-full pb-[14px]">
        {children}
        <span className="absolute top-[9px] left-[160px] bg-[#5882C1] text-white text-[10px] px-1.5 py-0.5 rounded-full min-w-[20px] flex items-center justify-center font-bold pointer-events-none">
          {content}
        </span>
      </div>
    );
  }

  return <div className="w-full pb-[14px]">{children}</div>;
}

DrawerSubMenuItem.propTypes = {
  /**
   * Badge content
   */
  content: PropTypes.number.isRequired,
  /**
   * Element children to be render
   */
  children: PropTypes.element.isRequired,
};

export default DrawerSubMenuItem;
